import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}
// 预渲染（SSG）生成的静态 HTML 已包含完整正文，供搜索引擎直接读取；
// 客户端接管时清空并由 React 重新渲染，避免重复内容。
container.innerHTML = '';

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
